import React, { Component } from "react";
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { sendRequest } from '../redux/actions/dataActions'; 

import './styles/contact.css';

export class contact extends Component {

    constructor(){
        super();
        this.state = {
            email: '',
            name: '',
            subject: '',
            text: '',
            errors: {}
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({
            loading: true
        });
        const newUserData = {
            email: this.state.email,
            name: this.state.name,
            subject: this.state.subject,
            text: this.state.text
        }

        console.log(newUserData);

        const pushData = {
            email: this.state.email[0],
            name: this.state.name[0],
            subject: this.state.subject[0],
            text: this.state.text
        }

        console.log(pushData);

        this.props.sendRequest(pushData, this.props.history);
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: [event.target.value]
        })
    }

    handleDateChange = (event) => {
        let value = event.target.value

        if(!isNaN(value)){
            this.handleChange(event);
        }
    }

    getInitialState() {
      return {
      text : this.props.note.body
  }
}

  render() {
    const{UI: { loading }} = this.props;
    const {errors } = this.state;
    return (
      <div className="ContactMain">
        <h1>Contact me</h1>
        <div className="ContactForm">
          <form noValidate onSubmit={this.handleSubmit}>
            <input type="hidden" name="bot-field" />
            <input type="hidden" name="form-name" value="Contact" />
            <input
              className="ContactField"
              type="name"
              name="name"
              id="name"
              onChange={this.handleChange}
              placeholder="Name"
              value = {this.state.name}
              error={errors.name ? true : false}
            />
            <br />
            <input 
            type="email" 
            name="email" 
            id="email" 
            onChange={this.handleChange}
            placeholder="E-Mail"
            value = {this.state.email} 
            error={errors.email ? true : false}
            />
            <br />
            <input
              type="text"
              name="subject"
              id="subject"
              onChange={this.handleChange}
              placeholder="Subject"
              value = {this.state.subject}
              error={errors.subject ? true : false}
            />
            <br />
            <textarea
            onChange={e => this.setState({ text : e.target.value })}
            value={this.state.text}
            ref={node => {this.textarea = node;}}
            placeholder="Message"
          />
            <br />
            <button type="submit" disabled={loading && errors !== {} }>Send</button>
          </form>
        </div>
      </div>
    );
  }
}

contact.propTypes = {
    classes: PropTypes.object.isRequired,
    ui: PropTypes.object.isRequired,
    sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    UI: state.ui
});

export default connect(mapStateToProps, { sendRequest })(contact);
